<template>
  <v-table class="mt-10">
    <thead>
    <tr class="font-weight-bold">
      <th class="text-left">
        You Are Paying For
      </th>
      <th class="text-left">
        Amount, AED
      </th>
      <th v-if="storage.provider.type_id !== 6" class="text-left">
        *Total Amount, AED
      </th>
      <th v-if="storage.provider.type_id === 6" class="text-left"></th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td class="bottom-grey">{{storage.provider.name}}</td>
      <td class="bottom-grey" colspan="2" v-if="storage.provider.type_id === 6">{{storage.amount}}</td>
      <td class="bottom-grey" v-if="storage.provider.type_id !== 6">{{storage.amount}}</td>
      <td class="bottom-grey" v-if="storage.provider.type_id !== 6">{{total}}</td>
    </tr>
    </tbody>
    <tbody v-for="field in storage.provider.fields" :key="field.field_name">
      <tr v-if="!storage.wallet">
        <td class="text-left font-weight-bold" style="border-bottom: 1px solid rgb(255, 255, 255);">{{ field.field_name }}:</td>
        <td style="border-bottom: 1px solid rgb(255, 255, 255);"></td>
        <td style="border-bottom: 1px solid rgb(255, 255, 255);"></td>
      </tr>
      <tr v-if="!storage.wallet">
        <td class="text-left bottom-grey">{{ storage['field'+field.id] }}</td>
        <td class="bottom-grey"></td>
        <td class="bottom-grey"></td>
      </tr>
    </tbody>
    <tbody v-if="storage.wallet">
      <tr>
        <td class="text-left font-weight-bold" style="border-bottom: 1px solid rgb(255, 255, 255);">Wallet:</td>
        <td style="border-bottom: 1px solid rgb(255, 255, 255);"></td>
        <td style="border-bottom: 1px solid rgb(255, 255, 255);"></td>
      </tr>
      <tr>
        <td class="text-left bottom-grey" colspan="3">{{ storage.wallet }}</td>
      </tr>
    </tbody>
    <tbody v-if="storage.description">
      <tr>
        <td class="text-left font-weight-bold" style="border-bottom: 1px solid rgb(255, 255, 255);">Denomination:</td>
        <td style="border-bottom: 1px solid rgb(255, 255, 255);"></td>
        <td style="border-bottom: 1px solid rgb(255, 255, 255);"></td>
      </tr>
      <tr>
        <td class="text-left bottom-grey" colspan="3">{{ storage.description }}</td>
      </tr>
    </tbody>
    <tbody v-if="storage.provider.type_id === 6">
      <tr>
        <td class="text-left font-weight-bold" style="border-bottom: 1px solid rgb(255, 255, 255);">Amount to account, USDT:</td>
        <td style="border-bottom: 1px solid rgb(255, 255, 255);"></td>
        <td style="border-bottom: 1px solid rgb(255, 255, 255);"></td>
      </tr>
      <tr>
        <td class="text-left bottom-grey" colspan="3">{{ storage.amount_to }}</td>
      </tr>
      <tr>
        <td class="text-left font-weight-bold" style="border-bottom: 1px solid rgb(255, 255, 255);">Top-up Request ID to pay on terminals:</td>
        <td style="border-bottom: 1px solid rgb(255, 255, 255);"></td>
        <td style="border-bottom: 1px solid rgb(255, 255, 255);"></td>
      </tr>
      <tr>
        <td class="text-left bottom-grey" colspan="1">{{ storage.otp}}</td>
        <td class="text-left bottom-grey" colspan="2"> Expires at {{ storage.expired_at}}</td>
      </tr>
    </tbody>
  <tbody v-if="storage.provider.type_id !== 6 || storage.isOnline === 1">
    <tr>
      <td class="text-left font-weight-thin font-italic" colspan="4" v-if="storage.provider.commission_ps">
        * Amount includes Commission {{storage.provider.name}} {{storage.provider.commission_ps}} AED Service Fee {{storage.provider.service_fee}}% and VAT {{storage.provider.processing_fee}}% on Service Fee
      </td>
      <td class="text-left font-weight-thin font-italic" colspan="4" v-if="storage.provider.service_fee && !storage.provider.commission_ps">
        * Includes {{storage.provider.service_fee}}% service fee + {{storage.provider.processing_fee}}% VAT on service fee
        (minimum fee AED {{storage.provider.service_fee_min}} + {{storage.provider.processing_fee}}% VAT applies)
      </td>
    </tr>
    </tbody>
  </v-table>

  <v-row class="mt-8" no-gutters justify="center">
    <v-col
      cols="12"
      align="center"
    >
      <v-btn
        v-if="storage.provider.type_id !== 6 || storage.isOnline === 1"
        color="success"
        @click="setToPay"
      >
        ACCEPT & CONTINUE
      </v-btn>
      <v-btn
        v-if="storage.isOnline === 0"
        color="info"
        @click="goToTerminals"
      >
        VIEW MAP WITH TERMINALS
      </v-btn>
    </v-col>
  </v-row>
  <v-row class="mt-5 texts-pay" v-if="showTermsAndConditions">
    <v-col>
      <div class="text-center">
        By clicking accept & continue you agree to our
        <a @click="setToRoute('cancellation_refund_policy')" >CANCELLATION & REFUND POLICE</a>
        and
        <a @click="setToRoute('terms_and_conditions')" >TERMS AND CONDITIONS</a>
      </div>
    </v-col>
  </v-row>
</template>

<script> /* eslint-disable */
import { inject, ref } from 'vue'
import router from '@/utils/router'
import axios from '@/utils/axios-http'

export default {
  data() {
    return {
      enabled: true,
    };
  },
  methods: {
    goToTerminals() {
      location = process.env.VUE_APP_TERMINALS
    }
  },
  name: 'PayView',
  setup (props, context) {
    const { storage, setStorage } = inject('storage')
    const { setToRoute } = inject('history')
    const showTermsAndConditions = process.env.VUE_APP_SHOW_TERMS_AND_CONDITIONS === 'true'
    let fields = {}
    Object.entries(storage.provider.fields).forEach(([key, value]) => {
      fields[value.field_name] = storage['field' +  value.id]
    })

    if (!storage.amount || !storage.provider) {
      router.push({ name: 'home' })
    } else {
      setStorage('overlay', false)
    }

    setStorage('showBack', true)

    let amount = 0

    if (storage.provider.round_type_id === 1) {
      amount = Math.floor(storage.amount * 100) / 100
    }

    if (storage.provider.round_type_id === 2) {
      amount = parseInt(storage.amount)
    }

    if (storage.provider.round_type_id === 3) {
      amount = Math.floor(parseInt(storage.amount) / 5) * 5
    }

    if (storage.provider.round_type_id === 4) {
      const current_amount = Number(storage.amount)
      amount = current_amount

      console.log(current_amount, amount)
      if (current_amount % 5 !== 0) {
        amount = Math.ceil(current_amount / 5) * 5
      }
    }

    if (amount < 5) {
      amount = 5
    }

    storage.amount = Number(amount).toFixed(2)

    if (storage.provider.commission_ps) {
      amount = amount + Number(storage.provider.commission_ps)
    }

    const serviceFee = amount * storage.provider.service_fee / 100 + storage.provider.service_fee_fix
    const processingFeeFix = serviceFee * storage.provider.processing_fee / 100
    const processingFeeMin = storage.provider.service_fee_min * storage.provider.processing_fee / 100
    const processingFeeAll = Math.max(serviceFee + processingFeeFix, storage.provider.service_fee_min + processingFeeMin)
    const total = Number(Math.ceil((amount + processingFeeAll) * 100) / 100).toFixed(2)
    const total_amount = Math.ceil((amount + processingFeeAll) * 100) / 100
    const enabled = ref(true)

    const setToPay = () => {
      enabled.value = false
      let session = ''
      let receipt = 0
      if (storage.session){
        session = storage.session
      }
      if (storage.receipt){
        receipt = storage.receipt
      }
      const numberOfVouchers = Math.floor(Number(storage.number_of_vouchers))
      if (numberOfVouchers > 0){
        fields['number_of_vouchers'] = numberOfVouchers.toString()
      }
      setStorage('overlay', true)
      if (storage.provider.type_id === 5){
        fields['wallet'] = storage.wallet
        fields['number'] = storage.number
      }
      if (storage.provider.type_id === 6){
        fields['otp_crypto'] = storage.otp
      }
      axios.post('noonpayments/init', {
        fields: fields,
        amount: amount,
        total_amount: total_amount,
        provider_id: storage.provider.id,
        session: session,
        receipt: receipt,
        account: storage.account,
        fields_ext: storage.fields_ext
      })
        .then(response => {
          setStorage('overlay', false)
          if (response.data && response.data.url) {
            location = response.data.url
          }
        })
    }

    return {
      storage,
      total,
      enabled,
      setToPay,
      setToRoute,
      showTermsAndConditions
    }
  }
}
</script>
<style>
  main {
    padding: 64px 0px 0px;
  }
  .bottom-grey {
    border-bottom: 1px solid rgb(225, 225, 225);
  }
  .texts-pay a {
    text-decoration: none;
    color: #1940e1;
  }
  .texts-pay {
    font-size: 11px;
  }
</style>
